import { EntityKind } from '../entity/entity-kind.js';
import { createPermission, PermissionRead } from '../permission/permissions.js';

export const PermissionClientStreamRead = createPermission(EntityKind.ClientStream, PermissionRead);